import React from 'react';
import 'react-table/react-table.css';
import DefaultReactTable, { multiSelectFilterColumn } from '../../utils/react-table';
import { uniq } from 'lodash';
import { Badge } from '../ui-kit';

// column definition for ReactTable
const createColumns = ({ allTypes }) => [
  {
    Header: I18n.t('attributes.id'),
    id: 'id',
    accessor: d => d.id,
    Cell: row => {
      const { id } = row.original;
      const url = `/pagers/${id}`;
      return (
        <a href={url} target="_blank" rel="noreferrer">
          {row.value}
        </a>
      );
    }
  },
  {
    Header: I18n.t('activerecord.attributes.user.name'),
    accessor: d => d.user.name,
    id: 'userName',
    Cell: row => {
      const { user } = row.original;
      const url = `/users/${user.id}`;
      return (
        <a href={url} target="_blank" rel="noreferrer">
          {row.value}
        </a>
      );
    }
  },
  multiSelectFilterColumn({
    Header: I18n.t('attributes.type'),
    id: 'type',
    accessor: d => d.type,
    selectOptions: allTypes.map(type => ({ value: type, html: type }))
  }),
  {
    Header: I18n.t('activerecord.attributes.mobile/pagers/pager.serial_number'),
    id: 'serial_number',
    accessor: d => d.serial_number
  },
  {
    Header: I18n.t('activerecord.attributes.mobile/pagers/pager.firmware_version'),
    id: 'firmware_version',
    accessor: d => d.firmware_version
  },
  {
    Header: I18n.t('attributes.last_seen_at'),
    id: 'last_seen_at',
    accessor: d => d.last_seen_at,
    Cell: row => row.original.last_seen_at_in_words,
    filterable: false
  },
  {
    Header: I18n.t('activerecord.attributes.mobile/pagers/pager.battery_level'),
    id: 'battery_level',
    accessor: d => d.battery_level,
    filterable: false
  },
  {
    Header: I18n.t('activerecord.attributes.mobile/pagers/pager.state'),
    id: 'state',
    accessor: d => d.state,
    Cell: row => (
      <Badge pill variant={row.original.state_badge_class}>
        {row.original.state}
      </Badge>
    ),
    filterable: true
  },
  {
    Header: I18n.t('activerecord.attributes.mobile/pagers/pager.oap_status'),
    id: 'oap_status',
    accessor: d => d.oap_status,
    Cell: row => (
      <Badge pill variant={row.original.oap_status_badge_class}>
        {row.original.oap_status}
      </Badge>
    ),
    filterable: true
  }
];

const PagersTable = ({ pagers, selectable, onSelectChange, selected }) => {
  const allTypes = uniq(pagers.map(d => d.type).filter(Boolean)).sort();

  return (
    <DefaultReactTable
      filterable
      showPaginationTop
      showPaginationBottom
      selectable={selectable}
      onSelectChange={onSelectChange}
      selected={selected}
      data={pagers}
      columns={createColumns({ allTypes })}
      defaultSorted={[{ id: 'id' }]}
      defaultFiltered={[{ id: 'type', value: allTypes }]}
      defaultPageSize={50}
    />
  );
};

export default PagersTable;
